import { bool, func } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Label } from 'reactstrap';

import SingleSelect from '../../../generic/SingleSelect';
import {
  salesUnits,
  salesUnitSalesTeams,
} from '../../../opportunities/constants';
import { userShape } from '../../../prop-types';
import { roleToRoles } from '../../constants';

export default function UserSalesUnit({ user, onChange, readOnly, newModel }) {
  const { salesUnit, salesTeam } = user;
  const inputProps = { onChange, readOnly };

  const checkSelectedRolesHasPC = (selectedRoles, allowedRoles) =>
    selectedRoles.some(item => allowedRoles.includes(item));

  const showSalesUnit =
    !newModel ||
    checkSelectedRolesHasPC(user.roles, roleToRoles.PARTNER_CONSULTANCY_LEAD);

  return (
    <>
      {showSalesUnit && (
        <FormGroup row>
          <Label sm={4} for="us-salesUnit" className="required">
            Sales Unit
          </Label>
          <Col sm={8}>
            <SingleSelect
              options={salesUnits}
              id="op-salesUnit"
              name="salesUnit"
              value={salesUnit}
              {...inputProps}
            />
          </Col>
        </FormGroup>
      )}
      {salesUnitSalesTeams[salesUnit]?.length > 0 && (
        <FormGroup row>
          <Label sm={4} for="us-salesTeam">
            Sales Team
          </Label>
          <Col sm={8}>
            <SingleSelect
              options={salesUnitSalesTeams[salesUnit]}
              id="us-salesTeam"
              name="salesTeam"
              value={salesTeam}
              {...inputProps}
            />
          </Col>
        </FormGroup>
      )}
    </>
  );
}

UserSalesUnit.propTypes = {
  user: userShape.isRequired,
  onChange: func,
  readOnly: bool,
  newModel: bool,
};

UserSalesUnit.defaultProps = {
  onChange: () => {},
  readOnly: undefined,
  newModel: false,
};
